import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const opportunityApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/opportunity",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/opportunity",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}`,
      method: "patch",
      data,
    }),
  approve: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}/approve`,
      method: "post",
    }),
  closeOrder: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}/close-order`,
      method: "post",
    }),
  reject: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}/reject`,
      method: "post",
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/opportunity/${id}`,
      method: "delete",
    }),
};
